import { render } from "./UploaderDataListManual.component.vue?vue&type=template&id=140a1008&scoped=true&ts=true"
import script from "./UploaderDataListManual.component.vue?vue&type=script&lang=ts"
export * from "./UploaderDataListManual.component.vue?vue&type=script&lang=ts"

import "./UploaderDataListManual.component.vue?vue&type=style&index=0&id=140a1008&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140a1008"]])

export default __exports__